"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RequiredMinimumDistributionRefineModal;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _RequiredMinimumDistributionModalFormControls = require("./RequiredMinimumDistributionModalFormControls");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RequiredMinimumDistributionRefineModal(props) {
  var {
    handleClose,
    snapshot,
    show,
    fetchDataScienceResults
  } = props;

  // Pulling formik context from higher up, which gives us access to formik state
  var {
    values: {
      birthDay,
      birthMonth,
      birthYear,
      spouseBirthDay,
      spouseBirthMonth,
      spouseBirthYear
    },
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    values,
    isSubmitting,
    isValid
  } = (0, _formik.useFormikContext)();
  var handleSubmit = e => {
    e.preventDefault();
    handleClose();
    // The second param we are passing is acting as the 'bag' that formik would usually give to us
    // when doing a handleSubmit. The function below relies on an object containing setFieldValue method, so we provide it
    fetchDataScienceResults(values, {
      setFieldValue: setFieldValue
    });
  };
  var showSpouse = beneficiary => {
    return beneficiary == 'my spouse';
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(snapshot),
    title: "Edit your inputs & our assumptions"
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Your Details"), /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionModalFormControls.BirthDay, {
    errors: errors,
    touched: touched,
    birthDay: birthDay,
    birthMonth: birthMonth,
    birthYear: birthYear,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    setFieldError: setFieldError
  }), /*#__PURE__*/_react.default.createElement("h3", null, "Beneficiary Information"), /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionModalFormControls.Beneficiary, {
    values: values,
    setFieldValue: setFieldValue
  }), showSpouse(values.beneficiary) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionModalFormControls.SpouseBirthDay, {
    errors: errors,
    touched: touched,
    spouseBirthDay: spouseBirthDay,
    spouseBirthMonth: spouseBirthMonth,
    spouseBirthYear: spouseBirthYear,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    setFieldError: setFieldError
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Retirement Account Information"), /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionModalFormControls.AccountBalance, {
    values: values,
    errors: errors,
    touched: touched
  }), /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionModalFormControls.RateOfReturn, {
    values: values,
    setFieldValue: setFieldValue,
    errors: errors,
    touched: touched
  }))))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "link",
    onClick: () => handleClose(snapshot)
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    disabled: isSubmitting || !isValid,
    onClick: handleSubmit
  }, "Update"))));
}